import Authorized from '@admin/components/authorized'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class SignatureFieldForm extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    program: PropTypes.object,
    onDone: PropTypes.func,
    onUpdate: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    profile_id: null,
    config: null
  }

  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleProfile = this._handleProfile.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    if(!this.state.config) return null
    return (
      <Authorized { ...this._getAuthorized() }>
        <Form { ...this._getForm() } />
      </Authorized>
    )
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this._getDefault(),
        ...this.props.config
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this.props.onUpdate(config)
    }
  }

  _getAuthorized() {
    return {
      label: 'Adobe Sign',
      image: '/images/services/adobesign.png',
      service: 'adobesign',
      type: 'signatures',
      onProfile: this._handleProfile
    }
  }

  _getForm() {
    const { config, profile_id } = this.state
    const { program } = this.props
    return {
      title: 't(Signature)',
      ref: this.formRef,
      onChange: this._handleChange,
      onSubmit: this._handleDone,
      cancelText: null,
      saveText: null,
      buttons: [
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: [
            { name: 'profile_id', type: 'hidden', value: profile_id },
            { name: 'program_id', type: 'hidden', value: program.id },
            { label: 't(Name)', name: 'name', type: 'tokenfield', required: true, value: config.name },
            { label: 't(Label)', name: 'label', type: 'textfield',  value: config.label },
            { label: 't(Instructions)', name: 'instructions', type: 'htmlfield', value: config.instructions },
            { label: 't(Placeholder)', name: 'placeholder', type: 'textfield',  value: config.placeholder },
            { label: 't(Required)', name: 'required', type: 'checkbox', prompt: 't(This field is required)', value: config.required },
            { label: 't(Prompt)', name: 'prompt', type: 'textfield', value: config.prompt },
            { label: 't(Document)', name: 'asset_id', type: 'attachmentfield', multiple: false, required: true,value: config.asset_id }
          ]
        }
      ]
    }
  }

  _getDefault() {
    return {
      label: '',
      name: {
        token: '',
        value: ''
      },
      instructions: '',
      placeholder: '',
      prompt: 'Sign Document',
      required: false
    }
  }

  _handleChange(config) {
    const { label } = config
    const name = _.get(config, 'name.value')
    this.setState({
      config: {
        ...this.state.config,
        ...config,
        ...config.name && ((!label && name.length === 1) || name.slice(0,-1) === label) ? {
          label: config.name.value
        } : {}
      }
    })
  }

  _handleDone() {
    this.props.onDone()
  }

  _handleProfile(profile) {
    this.setState({
      profile_id: profile.id
    })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}

export default SignatureFieldForm
